import { render } from "./TheDebugger.vue?vue&type=template&id=0376955a&scoped=true"
import script from "./TheDebugger.vue?vue&type=script&lang=js"
export * from "./TheDebugger.vue?vue&type=script&lang=js"

import "./TheDebugger.vue?vue&type=style&index=0&id=0376955a&scoped=true&lang=css"

import exportComponent from "/Users/nogglema/Documents/Ecampus/css-205-lab-2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0376955a"]])

export default __exports__